// formConfigVaga.js
export const formStructure = [
  [
    {
      name: 'Titulo',
      label: 'Título da Vaga',
      placeholder: 'Motorista',
      component: 'FormField',
      type: 'text',
      colProps: { md: 8 },
      required: true,
      maxLength: 200,
      validation: { required: 'Título é obrigatório' },
    },
    {
      name: 'NecessitaCNH',
      label: 'Necessita CNH?',
      placeholder: 'Selecione...',
      component: 'SearchSelect',
      isMulti: false,
      colProps: { md: 4 },
      required: true,
      options: [
        { label: 'Não', value: '0' },
        { label: 'Sim', value: '1' },
      ],
      validation: { required: 'Informe se a vaga necessita CNH' },
    },
  ],
  [
    {
      name: 'Endereco',
      label: 'Endereço / Local',
      placeholder: 'Ex.: Av. Paulista, 1000 - São Paulo/SP',
      component: 'FormField',
      type: 'text',
      colProps: { md: 12 },
      maxLength: 255,
    },
  ],
  [
    {
      name: 'Descricao',
      label: 'Descrição (curta)',
      placeholder: 'Resumo da vaga',
      component: 'FormField',
      type: 'text',
      colProps: { md: 12 },
      maxLength: 500,
    },
  ],
  [
    {
      name: 'DescricaoVaga',
      label: 'Descrição da Vaga (detalhada)',
      placeholder: 'Detalhes, stack, responsabilidades…',
      component: 'FormField',
      type: 'textarea',
      colProps: { md: 12 },
      rows: 5,
    },
  ],
  [
    {
      name: 'Salario',
      label: 'Salário',
      placeholder: 'Ex.: 9000.00',
      component: 'FormField',
      type: 'number',
      step: '0.01',
      colProps: { md: 12 },
    },
    {
      name: 'complementaresIds',
      label: 'Informações Complementares',
      placeholder: 'Selecione as opções...',
      component: 'FormField',
      type: 'multiselect',
      colProps: { md: 6 },
      optionsSource: 'complementares',
    },
    {
      name: 'beneficiosIds',
      label: 'Benefícios',
      placeholder: 'Selecione os benefícios...',
      component: 'FormField',
      type: 'multiselect',
      colProps: { md: 6 },
    },
  ],
];

export const formSections = (initialValues) => [
  {
    title: `Detalhes da Vaga ${initialValues?.Titulo ? `— ${initialValues.Titulo}` : ''}`,
    rows: [0, 1, 2, 3, 4],
  },
];


export const validateForm = (values) => {
  const errors = {};
  if (!values.Titulo || !values.Titulo.trim()) {
    errors.Titulo = 'Título é obrigatório';
  }
  if (values.NecessitaCNH === undefined || values.NecessitaCNH === '') {
    errors.NecessitaCNH = 'Informe se a vaga necessita CNH';
  }
  return errors;
};
